import { useState } from "react";
import axios from 'axios';
import { Box, Typography, Button, TextField } from '@mui/material';
import { loadFavicon, resetFavicon } from '../utils/Favicon';
import { REST_API_BASE_URL } from '../utils/utils';

function ForgotPassword() {
    const[email, setEmail] = useState();
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleChange = (event) => {
        const { value } = event.target;
        setEmail(value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        console.log("Email: " + email);
        loadFavicon();

        try {
          const response = await axios.post(REST_API_BASE_URL + 'forgotPassword', email, {
            headers: {
              'Content-Type': 'application/json'
            },
          });
    
          console.log(response.data);
          localStorage.setItem("email", email);
          setError(false);
          setSuccess(true);
        } catch (error) {
          console.error("Error submitting form:", error);
          setError(true);
        } finally {
          resetFavicon();
          setEmail("");
        }
    };

    return(
        <Box
          component="form"
          sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', paddingTop: '50px', gap:'10px'}}
          noValidate
          autoComplete="off"
          onSubmit={handleSubmit}
        >
            {error && <Box 
            sx={{ display: 'flex', justifyContent: 'center' }} 
            >
              <Typography 
                component={"p"} 
                variant="subtitle1" 
                color="error" 
              >
                Enter a valid Email ID.
              </Typography>
            </Box>}

            {success && <Box 
            sx={{ display: 'flex', justifyContent: 'center' }} 
            >
              <Typography 
                component={"p"} 
                variant="subtitle1" 
                color="success" 
              >
                Email has been sent successfully.
              </Typography>
            </Box>}

            <Typography
              variant="h6"
              sx={{ color: "text.primary", width:'35%' }}
            >
              Enter your email address:
            </Typography>
            <TextField 
              id="email" 
              label="Email" 
              name='email' 
              type='input' 
              value={email} 
              variant="standard" 
              sx={{ width: '35%' }} 
              onChange={handleChange} 
            />
            <Button 
              type="submit" 
              variant="outlined" 
              color='inherit' 
              sx={{ width: '20%',color: 'white', backgroundColor: 'red', '&:hover': { backgroundColor: '#8b0000' }}}
            >
              Submit
            </Button>
        </Box>
    )
}

export default ForgotPassword;